import { ColorScale } from '.'

export const yellow: ColorScale = {
  c10: '#312400',
  c20: '#4C3900',
  c30: '#684F00',
  c40: '#866600',
  c50: '#9B7700',
  c60: '#B58B00',
  c70: '#D5A400',
  c80: '#FCCE74',
  c90: '#FFEED6',
  c100: '#FFFFFF',
}
